export default __webpack_public_path__ + "static/developer_tablet-96d91c5a834eb4f8831987e0f1864fd9.png";